/* eslint-disable react-hooks/exhaustive-deps */
// External libraries
import { useEffect } from 'react';
import { IoIosCheckmarkCircle } from "react-icons/io";
import { BiSolidErrorCircle } from 'react-icons/bi';
import { AiOutlineClose } from "react-icons/ai";
import { useRecoilState } from 'recoil';

// CSS
import styles from "./Toast.module.css";

// Components
import { errorState } from '../../states';
import { Button, ButtonTheme, ButtonVariant } from '../button/Button';
import { MapToast } from './MapToast';

export const Toast = () => {
    const [error, setError] = useRecoilState(errorState);

    const onClose = () => {
        setError(null);
    };

    const getTypeClass = (type: string) => {
        if (!type) {
            return styles.error_toast;
        }

        let className = "";
        switch (type) {
            case 'Error':
                className = `${styles.error_toast}`;
                break;
            case 'Success':
                className = `${styles.success_toast}`;
                break;
            case 'Warning':
                className = `${styles.warning_toast}`;
                break;
            default:
                className = `${styles.success_toast}`;
        }
        return className;
    }

    useEffect(() => {
        if (error) {
            const timer = setTimeout(() => {
                onClose();
            }, 5000);
            return () => clearTimeout(timer);
        }
    }, [error]);

    if (!error) return null;

    return (
        <>
            {error?.type === 'MapInfo' ?
                <MapToast onClose={onClose} message={error?.message} />
                : <div className={`d-flex align-items-center justify-content-between ${styles.alert_box} ${getTypeClass(error?.type)}`}>
                    <div className='d-flex align-items-center'>
                        {(error?.type === 'Error' || error?.type === '' || error?.type === 'Warning')
                            ? <BiSolidErrorCircle className="fs-43" color='white' />
                            : <IoIosCheckmarkCircle className="fs-43" color='white' />}
                        <div className='margin-left-right-3'>
                            <h6 className={`${styles.alert_title} text-start margin-bottom-1 padding-0`}>{error?.type}</h6>
                            <p className={`${styles.alert_description} margin-0 padding-0 text-start`}>{error?.message}</p>
                        </div>
                    </div>
                    <div className='d-flex align-items-start h-100 padding-top-bottom-3 padding-right-1'>
                        <Button
                            theme={ButtonTheme.secondary}
                            variant={ButtonVariant.transparent}
                            onClick={onClose}
                            type='button'
                            classname='padding-left-right-0'
                        >
                            <AiOutlineClose className="fs-20" />
                        </Button>
                    </div>
                </div>
            }
        </>
    );
};
